export const MARKETING_SITE_REVISION = "0.15.011";

export function marketingBuildRevision(buildId?: string): string {
  const normalizedBuildId = buildId?.trim();
  if (!normalizedBuildId) return MARKETING_SITE_REVISION;
  return `${MARKETING_SITE_REVISION}+${normalizedBuildId}`.slice(0, 32);
}
